<template>

<MainLayout />

</template>

<script>
import MainLayout from '../components/MainLayout'
import {
    HTTP
} from '../http-common'

export default {
    components: {
        MainLayout
    },
    created() {
        HTTP.get('/auth/user-info')
            .then(response => {
                this.$store.commit('setUserInfo', response.data.data)
                if (!response.data.data || response.data.data.id == 0 || !response.data.data.id) {
                    this.$router.push({
                        name: 'login'
                    })
                }
            })
    }
}
</script>
